import { render, staticRenderFns } from "./BigName.vue?vue&type=template&id=44b4813c&scoped=true&"
import script from "./BigName.vue?vue&type=script&lang=js&"
export * from "./BigName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b4813c",
  null
  
)

export default component.exports